var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`app-button ${_vm.getClass} ${_vm.stateClass}`,attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[(!_vm.loading)?_c('span',[_vm._t("default")],2):_c('span',[_c('i',{staticClass:"fa fa-circle-notch fa-spin"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }